import { useCallback, useEffect } from 'react';
import { useGoogleOneTapLogin } from '@react-oauth/google';

import useAuth from '../hooks/useAuth';

const GoogleAuthHandler = ({onSuccess, useOneTap=false}) => {
  const { checkLogin, doLogin } = useAuth(onSuccess);
  
  const handleLoginSuccess = (response) => {
    const token = response.credential;
    doFdvBancLogin(token);
  }

  const doFdvBancLogin = useCallback((token) => {
    doLogin(token);
  }, [doLogin]);
  
  useEffect(() => {
    const loginStatus = checkLogin();
    if(loginStatus.status) {
      doFdvBancLogin(loginStatus.token);
    }
  }, [doFdvBancLogin, checkLogin]);

  useGoogleOneTapLogin({
    onSuccess: handleLoginSuccess,
    onError: () => {
      console.log('Login Failed');
    },
  });

  return null;

  /*
  return (
    <GoogleLogin
      onSuccess={handleLoginSuccess}
      onError={() => {
        console.log('Login Failed');
      }}
      useOneTap={useOneTap} // Activa el popup One Tap
    />
  );
  */
};

export default GoogleAuthHandler;
